import { chartDrawer, drawPresentLine } from './chartDrawer';
import { backgroundDrawer } from './backgroundDrawer';
import { drawBetBlocks } from './betBlockDrawer';
import { drawBetsHistory } from './betsHistoryDrawer';
import { drawPendingUnderOverBets } from './pendingUnderOverBetsDrawer';
import { drawWiningAnimation } from './winingAnimationDrawer';
import { doBetsStore } from '../../store';
import { roundStates } from '../../enums';

export const getRoundLifeCycle = () => {
  const { isShowBetBlocks, isBetBlocksClickable } = doBetsStore;

  if (isShowBetBlocks && isBetBlocksClickable) {
    return roundStates.roundStart;
  } else if (isShowBetBlocks && !isBetBlocksClickable) {
    return roundStates.betClosed;
  } else {
    return roundStates.roundFinished;
  }
};

const drawGame = () => {
  backgroundDrawer();
  drawBetsHistory();
  chartDrawer();
  drawBetBlocks();
  drawPendingUnderOverBets();
  drawPresentLine();
  drawWiningAnimation();
};

const drawIfRequiredRedrawGame = () => {
  const { isRequiredRedrawGame, setIsRequiredRedrawGame } = doBetsStore;
  isRequiredRedrawGame && drawGame();
  setIsRequiredRedrawGame(false);
};

const canvasDrawer = () => {
  switch (getRoundLifeCycle()) {
    case roundStates.roundStart:
      drawIfRequiredRedrawGame();
      break;
    case roundStates.betClosed:
      drawIfRequiredRedrawGame();
      break;
    case roundStates.roundFinished:
      drawGame();
  }
};

export default canvasDrawer;